<div fxLayout="column" fxLayoutAlign="center center">
    <h2 mat-dialog-title>{{'CONFING_RESUL_EMP.TITULO_MODAL' | translate}}</h2>
</div>
<div >{{'CONFING_RESUL_EMP.INT_TEX' | translate}}</div>
<mat-list>
  <mat-list-item>
    <mat-icon mat-list-icon>note</mat-icon>
    <div mat-line>Trust_Index©️ Raw Data</div>
    <div (click)="fileInput.click()" appDragDrop *ngIf="!fileFlagChange">
      <input hidden type="file" #fileInput (change)="cargaExcelTemplate($event)" >
      <button mat-mini-fab  class="mt-10"  color="primary" matTooltip="{{'CONFING_RESUL_EMP.TOOLT_CHA_INF' | translate}}">
        <mat-icon>note_add</mat-icon>
      </button>
    </div>
    <div *ngIf="fileFlagChange">
      <button mat-mini-fab  class="mt-10"  class="done" matTooltip="cargado correctamente">
        <mat-icon>check_circle</mat-icon>
      </button>
    </div>
  </mat-list-item>
  <mat-divider></mat-divider>
</mat-list>
